<template>
    <div>
        <h1 class="title title--line"><T :title="document.title">Het document werd niet herkend als @title</T></h1>
        <p>
            <T>Let op: laad zeker beide zijden van het document op.</T><br>
        </p>
        <a @click="$router.go(-1)" class="button button--ghost">
            <i class="icon-chevron-left button--icon button__icon--left"></i> <T>Klik hier om opnieuw te proberen</T>
        </a>
    </div>
</template>


<script>
    import {mapState} from 'vuex';

    export default {
        name: 'OcrRejected',
        data: function(){
            return {
                document: null,
            };
        },
        methods: {
            getDocument () {
                let self = this;
                self.$store.commit('setLoading',true);

                // get the current document
                this.$Api.get('document/' + this.$route.params.document)
                        .then(function(response) {
                            self.document = response.data;
                        })
            }
        },
        created: function() {
            this.getDocument();
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/OcrRejected.vue